module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-1.18fd814b.jpeg";